module.exports = "/_next/static/images/6a7f4a09086ff6e21922ac72d5fb10fb-man-holding-device-2@1.5x.jpg";